import React from 'react';

/**
 * Catches failures loading or running the 3D site view (a lazy chunk that can
 * fail to download, or a WebGL error) so they show a message instead of
 * taking down the whole app.
 */
export class SiteView3DBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error('3D site view failed:', error);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const loadFailed = /dynamically imported module|Loading chunk|Failed to fetch/i.test(error.message || '');
    return (
      <div style={{
        position: 'fixed', inset: 0, zIndex: 20000, background: 'rgba(8,12,16,0.96)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <div style={{ maxWidth: 440, padding: 24, color: '#c0d0e0', fontSize: 13, lineHeight: 1.6 }}>
          <div style={{ color: '#ffaa00', fontWeight: 600, marginBottom: 8 }}>The 3D view couldn't open</div>
          <div>
            {loadFailed
              ? 'The 3D viewer code failed to load. Refresh the page (if you run the app with npm run dev, restart it first) and try again.'
              : error.message}
          </div>
          <button
            onClick={() => { this.setState({ error: null }); this.props.onClose?.(); }}
            style={{
              marginTop: 16, background: 'rgba(0,200,255,0.2)', color: '#00c8ff',
              border: '1px solid rgba(0,200,255,0.4)', borderRadius: 4, padding: '6px 14px', cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
  }
}

export default SiteView3DBoundary;
